// Estado ao vivo do painel operacional/supervisor. Alimentado só via
// ActionCable, pelo stream DEDICADO do TelephonySupervisorPanelChannel
// (assinado em useSupervisorPanelChannel.js quando a página monta — o
// snapshot não passa pelo canal account_{id} genérico). Não tem fetch
// inicial via REST: o primeiro snapshot chega no próximo broadcast (a cada
// ~5s).
export const state = {
  updatedAt: null,
  wsConnected: false,
  equipes: [],
  agentes: [],
  filas: [],
  extensoes: [],
  chamadas: [],
  troncos: [],
  // { [userId]: [queueName, ...] } — ver Telephony::Supervisor::QueueAssignment.
  // Só usado pra filtro de UI (não é isolamento de dado — ver useSupervisorScope.js).
  supervisorAssignments: {},
  // { [kind]: { error, since } } — sync de métrica que está falhando no
  // backend (Telephony::Supervisor::Panel#run_sync). Vazio = tudo em dia.
  syncFailures: {},
  // true no dia do deploy da troca do t_oc (só-voz): o acumulado de antes da
  // atualização ainda tem WhatsApp aberto dentro (ver DailyAgentLog).
  tOcIncludesWhatsapp: false,
};

export const getters = {
  getUpdatedAt: $state => $state.updatedAt,
  getWsConnected: $state => $state.wsConnected,
  getEquipes: $state => $state.equipes,
  getAgentes: $state => $state.agentes,
  getFilas: $state => $state.filas,
  getExtensoes: $state => $state.extensoes,
  getChamadas: $state => $state.chamadas,
  getTroncos: $state => $state.troncos,
  getSupervisorAssignments: $state => $state.supervisorAssignments,
  getSyncFailures: $state => $state.syncFailures,
  getTOcIncludesWhatsapp: $state => $state.tOcIncludesWhatsapp,
};

export const actions = {
  // Chamado pelo ActionCable quando o backend manda um snapshot novo.
  handleRealtimeEvent({ commit }, event) {
    const { event_type: eventType, data } = event;

    switch (eventType) {
      case 'snapshot':
        commit('SET_SNAPSHOT', data);
        break;
      default:
        break;
    }
  },
};

export const mutations = {
  SET_SNAPSHOT($state, data) {
    $state.updatedAt = data.updated_at;
    $state.wsConnected = data.ws_connected;
    $state.equipes = data.equipes || [];
    $state.agentes = data.agentes || [];
    $state.filas = data.filas || [];
    $state.extensoes = data.extensoes || [];
    $state.chamadas = data.chamadas || [];
    $state.troncos = data.troncos || [];
    $state.supervisorAssignments = data.supervisor_assignments || {};
    $state.syncFailures = data.sync_failures || {};
    $state.tOcIncludesWhatsapp = data.t_oc_inclui_whatsapp === true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
